import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { Layout } from "@/components/Layout";
import { LeadForm } from "@/components/LeadForm";
import { SITE } from "@/data/site";
import { Check } from "lucide-react";

export const POPTAVKA_PAGE = {
  path: "/poptavka",
  seo: {
    title: "Poptávka teambuildingu | Extreme Teambuilding",
    description: "Nezávazná poptávka firemního teambuildingu Mission Ještěd. Stačí počet lidí, termín a rozpočet — návrh mise připravíme na míru.",
    schema: ["BreadcrumbList"],
  },
  breadcrumbs: [
    { label: "Úvod", href: "/" },
    { label: "Poptávka", href: "/poptavka" },
  ],
};

export function PoptavkaPage() {
  return (
    <Layout breadcrumbs={POPTAVKA_PAGE.breadcrumbs}>
      <Seo page={POPTAVKA_PAGE} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 grid lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <p className="text-xs font-mono font-bold uppercase tracking-[0.25em] text-amber">POPTÁVKA</p>
          <h1 className="font-display font-extrabold uppercase tracking-tight leading-[0.95] text-white text-4xl sm:text-5xl mt-4">Připravíme vám misi</h1>
          <p className="text-base md:text-lg text-mist mt-4 leading-relaxed">
            Nezávazná nabídka. Stačí počet lidí, termín a rozpočet — o zbytek se postaráme.
          </p>
          <ul className="mt-8 space-y-3" data-testid="poptavka-benefits">
            {[
              "Návrh mise na míru vašemu týmu",
              "Transparentní cena bez hvězdiček",
              "Jeden dodavatel pro celou akci",
              "Weather plan a bezpečnostní rámec",
            ].map((b) => (
              <li key={b} className="flex items-start gap-3 text-sm text-mist">
                <Check className="w-4 h-4 text-amber mt-0.5 shrink-0" aria-hidden="true" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
          <div className="mt-10 border border-line bg-surface p-5">
            <p className="text-xs font-mono uppercase tracking-[0.2em] text-dim">Přímý kontakt</p>
            <a href={`mailto:${SITE.email}`} className="text-white font-semibold mt-2 inline-block hover:text-amber transition-colors" data-testid="poptavka-email">{SITE.email}</a>
            <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} className="text-white font-semibold mt-1 block hover:text-amber transition-colors" data-testid="poptavka-phone">{SITE.phone}</a>
            <p className="text-xs text-dim mt-2">{SITE.company} · {SITE.address}</p>
          </div>
        </div>
        <div className="lg:col-span-3">
          <LeadForm />
        </div>
      </div>
    </Layout>
  );
}

export function ThankYouPage() {
  return (
    <Layout>
      <Seo page={{ path: "/dekujeme", seo: { title: "Děkujeme za poptávku | Extreme Teambuilding", description: "Vaše poptávka byla odeslána.", robots: "noindex,nofollow", schema: [] } }} />
      <div className="max-w-3xl mx-auto px-4 py-24 text-center" data-testid="thank-you-page">
        <p className="text-xs font-mono font-bold uppercase tracking-[0.25em] text-amber">POPTÁVKA ODESLÁNA</p>
        <h1 className="font-display font-extrabold uppercase tracking-tight text-white text-4xl sm:text-5xl mt-4">Mise se začíná připravovat.</h1>
        <p className="text-mist mt-5 max-w-xl mx-auto leading-relaxed">
          Děkujeme za poptávku. Ozveme se vám s nezávazným návrhem mise a cenou.
          Mezitím si můžete projít program Mission Ještěd nebo ceník.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
          <Link to="/mission-jested" className="bg-amber hover:bg-amberdark text-white font-display font-bold uppercase tracking-wide px-8 py-4 transition-colors" data-testid="thankyou-cta-mission">
            Zobrazit Mission Ještěd
          </Link>
          <Link to="/cenik" className="border border-linestrong text-white hover:border-amber hover:text-amber font-display font-bold uppercase tracking-wide px-8 py-4 transition-colors" data-testid="thankyou-cta-cenik">
            Zobrazit ceník
          </Link>
        </div>
      </div>
    </Layout>
  );
}
